export default "__VITE_ASSET__Drq7cuzt__"